import type { ImportStatus } from '@up2d8/contracts';

/**
 * Waar een import staat, zoals het scherm het moet uitleggen.
 *
 * - `done`: verwerkt; samenvatting, rapport en brieven.
 * - `failed`: stukgelopen; de reden.
 * - `running`: bevestigd en in de worker; de voortgangsbalk.
 * - `notCommitted`: ingelezen, kolommen gezet of een voorbeeld bekeken, maar nooit bevestigd. Er is
 *   niets aan de medewerkers gewijzigd en er gebeurt ook niets meer vanzelf.
 *
 * Die laatste kreeg vroeger de voortgangsbalk ("0 van 2 rijen verwerkt…"): wie een import alleen
 * bekeek, dacht dat hij nog liep (testrapport 28 okt., fout 18).
 */
export type ImportStage = 'done' | 'failed' | 'running' | 'notCommitted';

export function importStage(status: ImportStatus): ImportStage {
  switch (status) {
    case 'completed':
      return 'done';
    case 'failed':
      return 'failed';
    case 'processing':
      return 'running';
    case 'uploaded':
    case 'mapped':
    case 'previewed':
      return 'notCommitted';
  }
}

/**
 * De bestandsnaam van het importrapport: `importrapport-hr-export.csv` en niet
 * `importrapport-hr-export.csv.csv`. Het rapport is altijd CSV, ook bij een xlsx-bestand.
 */
export function reportFileName(fileName: string): string {
  const base = fileName.replace(/\.(csv|tsv|txt|xlsx?)$/i, '') || 'import';
  return `importrapport-${base}.csv`;
}
